import Close from "../assets/close.svg";
import { useEscape } from "../hooks/useEscape";

export default function SelectFscMethodForDownload({
  setFscMethodTrigger,
  setFscMethod,
}) {
  const handleClose = () => {
    setFscMethodTrigger(false);
    setFscMethod();
  };

  const updateMethod = (e) => {
    setFscMethod(parseInt(e.target.id));
    setFscMethodTrigger(false);
  };

  useEscape(setFscMethodTrigger, [setFscMethod], [0])

  return (
    <div className="popup">
      <div className="popup-fixed-height-width">
        <div className="close">
          <img onClick={handleClose} src={Close} alt="close" />
        </div>
        <h3>FSC Method for Download</h3>
        <div className="d-flex justify-content-center">
          <button
            id="7"
            className="fsc-btn"
            name="Per ST"
            onClick={updateMethod}
          >Per ST</button>
          <button
            id="8"
            className="fsc-btn"
            name="Flat"
            onClick={updateMethod}
          >Flat</button>
          <button
            id="40"
            className="fsc-btn"
            name="Per Mile"
            onClick={updateMethod}
          >Per Mile</button>
        </div>
      </div>
    </div>
  );
}
